export const BOTTOM_SHEET_ANIMATION_DURATION_SHORT = 100;
export const BOTTOM_SHEET_ANIMATION_DURATION_LONG = 300;
export const BOTTOM_SHEET_ANIMATION_EASING = 'cubic-bezier(0, .09, .4, 1)';
